import request from '@services/request'

export const getState = async ({ loanNumber }) => {
  return await request.get(`/applications/${loanNumber}/state`)
}

export default {
  getState,
}
